export default __webpack_public_path__ + "static/media/fintechinnovation.fa2202a7.svg";